import React, { useState } from "react";
import styles from "../../styles.module.scss";
import { I18n } from "@td/shared_utils";
import PracticeTeamSearchForm from "./form";
import PracticeTeamSearchResults from "./results";

const PracticeTeamSearch = () => {
  const [searchParams, setSearchParams] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  return (
    <div>
      <h1>
        <I18n scope="practice_team" text="search_title" />
      </h1>
      <span>
        <I18n scope="practice_team.index" text="sub_title" />
      </span>
      <div className={styles.addMenu}>
        <a href={Routes.new_practice_team_path()} className={`button ${styles.addPracticeTeam}`}>
          <I18n scope="practice_team.actions" text="add" />
        </a>
      </div>
      <div className="search">
        <h4>
          <I18n scope="practice_team.search" text="label" />
        </h4>
        <PracticeTeamSearchForm
          setSearchParams={setSearchParams}
          isFetching={isFetching}
        />
      </div>
      {searchParams && (
        <PracticeTeamSearchResults
          searchParams={searchParams}
          setIsFetching={setIsFetching}
        />
      )}
    </div>
  );
};

export default PracticeTeamSearch;
